module.exports = __webpack_public_path__ + "media/images/icons/filled/slack-square-197a59625504b71322fa30f65b1d1a9d.svg";